export enum TraderType {
    Ltd = 1000,
    Partnership = 1001,
    PrivateIndividual = 1002,
    SoleTrader = 1003,
    UnlimitedCompany = 1004,
    LLP = 1011,
  }
  